import { Box, CircularProgress } from "@mui/material";
import AvailabilityForm from "app/components/AddAvailability/utils/AvailabilityForm";
import { useLazyGetItemDetailsQuery } from "lib/features/item/itemService";
import { selectUser } from "lib/features/user/userSlice";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { addAvailabilityStyles } from "styles/AvailabilityDirectory/addAvailability.styles";

const AddAvailability = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const itemId = id ? parseInt(id, 10) : undefined;
  const user = useSelector(selectUser);

  const [getItemDetails, { data: itemDetails, isLoading }] =
    useLazyGetItemDetailsQuery();

  useEffect(() => {
    if (itemId) {
      getItemDetails(itemId);
    }
  }, [itemId, getItemDetails]);

  useEffect(() => {
    if (
      itemDetails &&
      itemDetails.business &&
      itemDetails.business.business_users[0]?.id !== user?.id
    ) {
      navigate(-1);
    }
  }, [itemDetails, navigate, user?.id]);

  return (
    <div>
      {isLoading && (
        <Box sx={addAvailabilityStyles.loaderContainer}>
          <CircularProgress />
        </Box>
      )}
      {!isLoading && itemDetails && user?.id && (
        <AvailabilityForm itemDetails={itemDetails} />
      )}
    </div>
  );
};

export default AddAvailability;
